import { PageContext } from '../context/page-context';
import { NoteSlideStore } from '../store/note-slide-store';
import { NoteSlideProps } from '../props/page/note-slide-props';
import { PageMutationAPI } from '../api/page-mutation-api';
import { PageDataModel } from './page-data-model';
import type { IEventManager } from '../manager/event-manager';
import type { INoteSlideProps } from '../props/page/note-slide-props';
import type { INoteSlideData } from '../data';
import type { SlideDataModel } from './slide-data-model';
import type { RestrictedDataModel } from './data-model';
import type { PresentationDataModel } from './presentation-data-model';

export class NoteSlideDataModel extends PageDataModel<INoteSlideData, INoteSlideProps> {
    public store: NoteSlideStore;
    public props: INoteSlideProps;
    public api: PageMutationAPI<NoteSlideDataModel>;
    public context: PageContext;

    public constructor(data: INoteSlideData, events: IEventManager, public parent: PresentationDataModel) {
        super(events, parent);

        this.context = new PageContext(data.type);
        this.store = new NoteSlideStore(data, events, this.context, this);
        this.props = new NoteSlideProps(this.store.data, this.context);
        this.api = new PageMutationAPI(this, events);

        this.context.setPresentation(this.parent);
        this.context.setPage(this);
        this.context.setTarget(this);

        const slide = parent.store.slideList.findById(data.slideId);
        this.context.setSlide(slide as SlideDataModel);
    }

    public get note() {
        return this.store.note;
    }

    public getSlide() {
        return this.context.getSlide();
    }
}

export { INoteSlideProps };
export type INoteSlideDataModel = RestrictedDataModel<NoteSlideDataModel>;
